export const INBOX_EMAIL = "info@readalsystems.com";

export async function sendInboxEmail(fields, subject) {
  const response = await fetch(
    `https://formsubmit.co/ajax/${INBOX_EMAIL}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        ...fields,
        _subject: subject,
        _template: "table",
        _captcha: "false",
        _honey: "",
      }),
    }
  );

  const payload = await response.json().catch(() => ({}));
  const failed =
    !response.ok ||
    payload.success === false ||
    payload.success === "false";

  if (failed) {
    throw new Error(payload.message || "Could not send the message.");
  }
}
